import { render, staticRenderFns } from "./itemForm.vue?vue&type=template&id=15b20810&"
import script from "./itemForm.vue?vue&type=script&lang=js&"
export * from "./itemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports